import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="hero" className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden border-b border-gridline pt-24 md:pt-32 pb-12" data-id="element-144">
      <video className="absolute inset-0 h-full w-full object-cover" autoPlay muted loop playsInline poster="https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=2000&q=80" aria-hidden="true" data-id="element-145">
        <source src="https://cdn.magicpatterns.com/uploads/h37YHzjf96SFjb1mvkEBfK/7653242-sd_960_506_25fps.mp4" type="video/mp4" data-id="element-146" />
      </video>
      <div className="absolute inset-0 bg-black/70" aria-hidden="true" data-id="element-147" />

      <div className="relative z-10 px-6 text-center max-w-5xl" data-id="element-148">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-white font-black uppercase leading-[0.9] tracking-tight text-3xl sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-149">
          Sip. Savour.
          <br data-id="element-150" />
          <motion.span initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-accent inline-block" data-id="element-151">
            Celebrate.
          </motion.span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="mt-8 mx-auto max-w-2xl text-white/70 text-sm md:text-lg leading-relaxed tracking-wide" data-id="element-152">
          Premium Cocktails, Mocktails, and Gourmet Small Chops — crafted to
          perfection, served with sophistication.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-153">
          <a href="#book" className="w-full sm:w-auto bg-accent text-black font-black uppercase tracking-[0.2em] text-xs md:text-sm px-8 py-4 hover:bg-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-154">
            Book Consultation
          </a>
          <a href="#menu" className="w-full sm:w-auto border border-white/30 text-white font-black uppercase tracking-[0.2em] text-xs md:text-sm px-8 py-4 hover:bg-white hover:text-black transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-155">
            View Packages
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-16 md:mt-24 grid grid-cols-3 gap-4 md:gap-12 border-t border-white/10 pt-8 max-w-3xl mx-auto" data-id="element-156">
          <div className="text-center" data-id="element-157">
            <span className="block text-2xl md:text-4xl font-black text-accent mb-1" data-id="element-158">
              10+
            </span>
            <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/50 font-bold" data-id="element-159">
              Years Exp.
            </span>
          </div>
          <div className="text-center border-x border-white/10" data-id="element-160">
            <span className="block text-2xl md:text-4xl font-black text-white mb-1" data-id="element-161">
              500+
            </span>
            <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/50 font-bold" data-id="element-162">
              Events
            </span>
          </div>
          <div className="text-center" data-id="element-163">
            <span className="block text-2xl md:text-4xl font-black text-white mb-1" data-id="element-164">
              5★
            </span>
            <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/50 font-bold" data-id="element-165">
              Rated
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}